import * as actionTypes from "./actionTypes";
import vediApi from "../../utils/vedi-api/vediAPI";
import { TOKEN } from "../../constants";
import { cookieValue } from "../../utils/helper";

const token = cookieValue(TOKEN);

export const setAdminApps = (applications) => ({
  type: actionTypes.SET_ADMIN_APPS,
  payload: applications || [],
});

export const setApp = (application) => ({
  type: actionTypes.SET_APPLICATION,
  payload: application || {},
});

export const AltaEmpleado = (empleados) => {
  vediApi
    .put("/v3/Usuario/AltaEmpleado", {
      headers: { "--Token": token },
      empleados,
    })
    .then(({ data }) => {
      return;
    })
    .catch((error) => {
      console.error("Error", error);
    });
};

export const GetUsuariosByCUILS = (cuils) => {
  return vediApi
    .post("/v3/Usuario/GetUsuariosByCUILS", {
      headers: { "--Token": token },
      cuils,
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error("Error", error);
    });
};

export const SaveApplication = (applicationData) => {
  return async (dispatch) => {
    try {
      const { IdApplication, ...rest } = applicationData;
      const url = IdApplication
        ? `/v3/Usuario/GuardarAplicacion?IdAplicacion=${IdApplication}`
        : "/v3/Usuario/GuardarAplicacion";

      const response = await vediApi.post(url, rest, {
        headers: { "--Token": token },
      });

      if (response?.data?.ok) {
        dispatch({
          type: actionTypes.SAVE_APPLICATION,
          payload: response.data.return,
        });

        return response.data;
      } else {
        throw new Error("Error al guardar la aplicación");
      }
    } catch (error) {
      console.error("Error al guardar la aplicación:", error);
    }
  };
};

export const UpdateShowInPanel = (IdApplication, showInPanel) => {
  return async () => {
    try {
      const { data } = await vediApi.post(
        `/v3/Usuario/MostrarAplicacionEnPanel?idAplicacion=${IdApplication}`,
        { MuestraPanel: showInPanel },
        { headers: { "--Token": token } }
      );

      return data.ok;
    } catch (error) {
      console.error("Error al actualizar la visibilidad en panel:", error);
    }
  };
};

export const UpdateShowInMobile = (IdApplication, showInMobile) => {
  return async () => {
    try {
      const { data } = await vediApi.post(
        `/v3/Usuario/MostrarAplicacionEnMovil?idAplicacion=${IdApplication}`,
        { MuestraMovil: showInMobile },
        { headers: { "--Token": token } }
      );

      return data.ok;
    } catch (error) {
      console.error("Error al actualizar la visibilidad en móvil:", error);
    }
  };
};

export const ToggleActivateApplication = (IdApplication) => {
  return async (dispatch) => {
    try {
      const { data } = await vediApi.post(
        `/v3/Usuario/ActivarAplicacion?IdAplicacion=${IdApplication}`,
        { headers: { "--Token": token } }
      );

      if (data) {
        dispatch({
          type: actionTypes.TOGGLE_APPLICATION,
          payload: IdApplication,
        });

        return data;
      } else {
        throw new Error("Error en la activación/desactivación");
      }
    } catch (error) {
      console.error("Error al activar/desactivar la aplicación:", error);
      throw error;
    }
  };
};

const getApiData = (url, status = 1) => {
  return vediApi
    .get(url, {
      headers: { "--Token": token, "--Estado": status },
    })
    .then((data) => data)
    .catch((error) => {
      console.error("Error", error);
    });
};

export const GetApplication = (IdApplication) => {
  return async (dispatch) => {
    const { data } = await getApiData(
      `/v3/Usuario/ObtenerAplicacion?IdAplicacion=${IdApplication}`
    );

    if (data.ok) {
      dispatch(setApp(data.return));
      return data.return;
    }
  };
};

export const GetApplications = (status = 1) => {
  return async (dispatch) => {
    const { data } = await getApiData(
      "/v3/Usuario/ObtenerAplicaciones",
      status
    );

    if (data.ok) {
      dispatch(setAdminApps(data.return));
    }
  };
};

export const SetRole = (idRol, cuil) => {
  return vediApi
    .post("/v3/Usuario/AsignarRol", {
      headers: { "--Token": token },
      IdRol: idRol,
      Cuil: cuil,
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      console.error("Error", error);
    });
};

export const ResetCredentials = (idAplicacion) => {
  return async (dispatch) => {
    try {
      const { data } = await vediApi.post(
        `/v3/Usuario/ResetCredenciales?IdAplicacion=${idAplicacion}`,
        { headers: { "--Token": token } }
      );

      if (data) {
        dispatch({
          type: actionTypes.RESET_CREDENTIALS,
          payload: idAplicacion,
        });

        return data;
      } else {
        throw new Error("Error en la activación/desactivación");
      }
    } catch (error) {
      console.error("Error al activar/desactivar la aplicación:", error);
      throw error;
    }
  };
};

export const DeleteContactoApplication = async (IdContacto, tipo) => {
  try {
    const { data } = await vediApi.delete(
      `/v3/Usuario/ContactoAplicacion/${tipo}/?id=${IdContacto}`,
      { headers: { "--Token": token } }
    );

    if (data) {
      return data;
    } else {
      throw new Error("Error al eliminar el contacto de la aplicación");
    }
  } catch (error) {
    console.error("Error al eliminar el contacto de la aplicación:", error);
    throw error;
  }
};
